import React from 'react'
const apiPath = "/fw_manager/v1/";
export function isDev(): boolean
{
    return '_self' in React.createElement('div');
}

export default apiPath
